import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=fdbb3998&scoped=true"
import script from "./TooltipButton.vue?vue&type=script&lang=js"
export * from "./TooltipButton.vue?vue&type=script&lang=js"
import style0 from "./TooltipButton.vue?vue&type=style&index=0&id=fdbb3998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbb3998",
  null
  
)

export default component.exports